import type * as Types from '../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type CreateJoyFeatureCheckoutMutationVariables = Types.Exact<{
  data: Types.CreateJoyFeatureCheckoutInput;
}>;

export type CreateJoyFeatureCheckoutMutation = {
  __typename?: 'Mutation';
  createJoyFeatureCheckout: { __typename?: 'StartStationeryCheckoutResponse'; checkoutUrl?: string | null };
};

export type CreateJoyFeatureEmbeddedCheckoutMutationVariables = Types.Exact<{
  data: Types.CreateJoyFeatureCheckoutInput;
}>;

export type CreateJoyFeatureEmbeddedCheckoutMutation = {
  __typename?: 'Mutation';
  createJoyFeatureEmbeddedCheckout: { __typename?: 'JoyFeatureEmbeddedCheckoutResponse'; clientSecret: string; publishableKey: string };
};

export type GetJoyFeatureCheckoutSavedAddressQueryVariables = Types.Exact<{
  eventId: Types.Scalars['String'];
}>;

export type GetJoyFeatureCheckoutSavedAddressQuery = {
  __typename?: 'Query';
  stationeryMostRecentShippingAddressByEvent?: {
    __typename?: 'StationeryPrintOrderShippingAddress';
    name: string;
    address1: string;
    address2?: string | null;
    city: string;
    region: string;
    postalCode: string;
    country: string;
    countryCode: string;
  } | null;
};

export type HasJoyFeatureSubscriptionQueryVariables = Types.Exact<{
  eventId: Types.Scalars['String'];
  featureType: Types.JoyFeatureType;
}>;

export type HasJoyFeatureSubscriptionQuery = { __typename?: 'Query'; hasJoyFeatureSubscription: boolean };

export type JoyFeatureCheckoutStationeryProductsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type JoyFeatureCheckoutStationeryProductsQuery = {
  __typename?: 'Query';
  stationeryProducts: Array<{
    __typename?: 'StationeryProduct';
    id: string;
    priceConfigId: string;
    priceCurrency: string;
    pricing:
      | { __typename?: 'StationeryFlatFeePricing'; priceInMinorUnits: number }
      | { __typename?: 'StationeryTieredFlatFeePricing'; priceTiers: Array<{ __typename?: 'StationeryTieredFlatFeePrice'; minQuantity: number; totalPriceInMinorUnits: number }> }
      | { __typename?: 'StationeryTieredPricing'; priceTiers: Array<{ __typename?: 'StationeryTieredPrice'; minQuantity: number; unitPriceInMinorUnits: number }> };
  }>;
};

export const CreateJoyFeatureCheckoutDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateJoyFeatureCheckout' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateJoyFeatureCheckoutInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createJoyFeatureCheckout' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'checkoutUrl' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateJoyFeatureCheckoutMutationFn = Apollo.MutationFunction<CreateJoyFeatureCheckoutMutation, CreateJoyFeatureCheckoutMutationVariables>;

/**
 * __useCreateJoyFeatureCheckoutMutation__
 *
 * To run a mutation, you first call `useCreateJoyFeatureCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJoyFeatureCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJoyFeatureCheckoutMutation, { data, loading, error }] = useCreateJoyFeatureCheckoutMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateJoyFeatureCheckoutMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<CreateJoyFeatureCheckoutMutation, CreateJoyFeatureCheckoutMutationVariables>,
) {
  return ApolloReactHooks.useMutation<CreateJoyFeatureCheckoutMutation, CreateJoyFeatureCheckoutMutationVariables>(CreateJoyFeatureCheckoutDocument, baseOptions);
}
export type CreateJoyFeatureCheckoutMutationHookResult = ReturnType<typeof useCreateJoyFeatureCheckoutMutation>;
export type CreateJoyFeatureCheckoutMutationResult = Apollo.MutationResult<CreateJoyFeatureCheckoutMutation>;
export type CreateJoyFeatureCheckoutMutationOptions = Apollo.BaseMutationOptions<CreateJoyFeatureCheckoutMutation, CreateJoyFeatureCheckoutMutationVariables>;
export const CreateJoyFeatureEmbeddedCheckoutDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateJoyFeatureEmbeddedCheckout' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateJoyFeatureCheckoutInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createJoyFeatureEmbeddedCheckout' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publishableKey' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateJoyFeatureEmbeddedCheckoutMutationFn = Apollo.MutationFunction<CreateJoyFeatureEmbeddedCheckoutMutation, CreateJoyFeatureEmbeddedCheckoutMutationVariables>;

/**
 * __useCreateJoyFeatureEmbeddedCheckoutMutation__
 *
 * To run a mutation, you first call `useCreateJoyFeatureEmbeddedCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJoyFeatureEmbeddedCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJoyFeatureEmbeddedCheckoutMutation, { data, loading, error }] = useCreateJoyFeatureEmbeddedCheckoutMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateJoyFeatureEmbeddedCheckoutMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<CreateJoyFeatureEmbeddedCheckoutMutation, CreateJoyFeatureEmbeddedCheckoutMutationVariables>,
) {
  return ApolloReactHooks.useMutation<CreateJoyFeatureEmbeddedCheckoutMutation, CreateJoyFeatureEmbeddedCheckoutMutationVariables>(
    CreateJoyFeatureEmbeddedCheckoutDocument,
    baseOptions,
  );
}
export type CreateJoyFeatureEmbeddedCheckoutMutationHookResult = ReturnType<typeof useCreateJoyFeatureEmbeddedCheckoutMutation>;
export type CreateJoyFeatureEmbeddedCheckoutMutationResult = Apollo.MutationResult<CreateJoyFeatureEmbeddedCheckoutMutation>;
export type CreateJoyFeatureEmbeddedCheckoutMutationOptions = Apollo.BaseMutationOptions<
  CreateJoyFeatureEmbeddedCheckoutMutation,
  CreateJoyFeatureEmbeddedCheckoutMutationVariables
>;
export const GetJoyFeatureCheckoutSavedAddressDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetJoyFeatureCheckoutSavedAddress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stationeryMostRecentShippingAddressByEvent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetJoyFeatureCheckoutSavedAddressQuery__
 *
 * To run a query within a React component, call `useGetJoyFeatureCheckoutSavedAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJoyFeatureCheckoutSavedAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJoyFeatureCheckoutSavedAddressQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetJoyFeatureCheckoutSavedAddressQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetJoyFeatureCheckoutSavedAddressQuery, GetJoyFeatureCheckoutSavedAddressQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetJoyFeatureCheckoutSavedAddressQuery, GetJoyFeatureCheckoutSavedAddressQueryVariables>(GetJoyFeatureCheckoutSavedAddressDocument, baseOptions);
}
export function useGetJoyFeatureCheckoutSavedAddressLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetJoyFeatureCheckoutSavedAddressQuery, GetJoyFeatureCheckoutSavedAddressQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetJoyFeatureCheckoutSavedAddressQuery, GetJoyFeatureCheckoutSavedAddressQueryVariables>(
    GetJoyFeatureCheckoutSavedAddressDocument,
    baseOptions,
  );
}
export type GetJoyFeatureCheckoutSavedAddressQueryHookResult = ReturnType<typeof useGetJoyFeatureCheckoutSavedAddressQuery>;
export type GetJoyFeatureCheckoutSavedAddressLazyQueryHookResult = ReturnType<typeof useGetJoyFeatureCheckoutSavedAddressLazyQuery>;
export type GetJoyFeatureCheckoutSavedAddressQueryResult = Apollo.QueryResult<GetJoyFeatureCheckoutSavedAddressQuery, GetJoyFeatureCheckoutSavedAddressQueryVariables>;
export const HasJoyFeatureSubscriptionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'HasJoyFeatureSubscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'featureType' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'JoyFeatureType' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasJoyFeatureSubscription' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'featureType' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'featureType' } } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useHasJoyFeatureSubscriptionQuery__
 *
 * To run a query within a React component, call `useHasJoyFeatureSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasJoyFeatureSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasJoyFeatureSubscriptionQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      featureType: // value for 'featureType'
 *   },
 * });
 */
export function useHasJoyFeatureSubscriptionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HasJoyFeatureSubscriptionQuery, HasJoyFeatureSubscriptionQueryVariables>) {
  return ApolloReactHooks.useQuery<HasJoyFeatureSubscriptionQuery, HasJoyFeatureSubscriptionQueryVariables>(HasJoyFeatureSubscriptionDocument, baseOptions);
}
export function useHasJoyFeatureSubscriptionLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HasJoyFeatureSubscriptionQuery, HasJoyFeatureSubscriptionQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<HasJoyFeatureSubscriptionQuery, HasJoyFeatureSubscriptionQueryVariables>(HasJoyFeatureSubscriptionDocument, baseOptions);
}
export type HasJoyFeatureSubscriptionQueryHookResult = ReturnType<typeof useHasJoyFeatureSubscriptionQuery>;
export type HasJoyFeatureSubscriptionLazyQueryHookResult = ReturnType<typeof useHasJoyFeatureSubscriptionLazyQuery>;
export type HasJoyFeatureSubscriptionQueryResult = Apollo.QueryResult<HasJoyFeatureSubscriptionQuery, HasJoyFeatureSubscriptionQueryVariables>;
export const JoyFeatureCheckoutStationeryProductsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'JoyFeatureCheckoutStationeryProducts' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stationeryProducts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priceConfigId' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StationeryProductPricings' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StationeryProductPricings' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryProduct' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priceCurrency' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pricing' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTieredPricing' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceTiers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minQuantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unitPriceInMinorUnits' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryTieredFlatFeePricing' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceTiers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'minQuantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'totalPriceInMinorUnits' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryFlatFeePricing' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'priceInMinorUnits' } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useJoyFeatureCheckoutStationeryProductsQuery__
 *
 * To run a query within a React component, call `useJoyFeatureCheckoutStationeryProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJoyFeatureCheckoutStationeryProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJoyFeatureCheckoutStationeryProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useJoyFeatureCheckoutStationeryProductsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<JoyFeatureCheckoutStationeryProductsQuery, JoyFeatureCheckoutStationeryProductsQueryVariables>,
) {
  return ApolloReactHooks.useQuery<JoyFeatureCheckoutStationeryProductsQuery, JoyFeatureCheckoutStationeryProductsQueryVariables>(
    JoyFeatureCheckoutStationeryProductsDocument,
    baseOptions,
  );
}
export function useJoyFeatureCheckoutStationeryProductsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<JoyFeatureCheckoutStationeryProductsQuery, JoyFeatureCheckoutStationeryProductsQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<JoyFeatureCheckoutStationeryProductsQuery, JoyFeatureCheckoutStationeryProductsQueryVariables>(
    JoyFeatureCheckoutStationeryProductsDocument,
    baseOptions,
  );
}
export type JoyFeatureCheckoutStationeryProductsQueryHookResult = ReturnType<typeof useJoyFeatureCheckoutStationeryProductsQuery>;
export type JoyFeatureCheckoutStationeryProductsLazyQueryHookResult = ReturnType<typeof useJoyFeatureCheckoutStationeryProductsLazyQuery>;
export type JoyFeatureCheckoutStationeryProductsQueryResult = Apollo.QueryResult<JoyFeatureCheckoutStationeryProductsQuery, JoyFeatureCheckoutStationeryProductsQueryVariables>;
